<template>
  <div>
    <b-card class="card-custom" header-tag="header" footer-tag="footer">
      <template v-slot:header>
        <div class="card-title">
          <h3 class="card-label">
            {{ $t("PROCESSING_ORDER_ITEMS") }}
            <i class="mr-2"></i>
            <small class="">{{ $t("LIST") }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <BackButton></BackButton>
          <v-btn
            color="btn-success"
            class="btn btn-light-success font-weight-bolder mr-2"
            @click="getXLS"
          >
            <i class="flaticon-list-1"></i>
            {{ $t("DOWNLOAD") }}
          </v-btn>
        </div>
      </template>
      <template>
        <b-row class="mx-3">
          <b-col :lg="6" :md="12">
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              :label="$t('SHOW_HIDE_COLUMNS')"
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 2">
                  <span>{{ item.text }}</span>
                </v-chip>
                <span v-if="index === 2" class="grey--text caption"
                  >(+{{ selectedHeaders.length - 2 }} others)</span
                >
              </template>
            </v-select>
          </b-col>
          <b-col :lg="6" :md="12">
            <v-text-field
              v-model="search"
              clearable
              hide-details
              append-icon="mdi-magnify"
              :label="$t('SEARCH')"
              single-line
            ></v-text-field>
          </b-col>

          <b-col>
            <v-data-table
              :headers="showHeaders"
              :items="items"
              item-key="customIndex"
              :search="search"
              show-group-by
              :items-per-page="-1"
            >
              <template v-slot:item.sumQuantity="{ item }">
                {{ item.sumQuantity }} ({{ item.unitShortName }})
              </template>
              <template v-slot:item.sumPackages="{ item }">
                {{ item.sumPackages }} ({{ item.packageName }})
              </template>
              <template v-slot:item.sumRequestedQuantity="{ item }">
                {{ item.sumRequestedQuantity }} ({{ item.unitShortName }})
              </template>
              <template v-slot:item.sumRequestedPackages="{ item }">
                {{ item.sumRequestedPackages }} ({{ item.packageName }})
              </template>
              <template v-slot:item.sumTotalQuantity="{ item }">
                {{ item.sumTotalQuantity }} ({{ item.unitShortName }})
              </template>
              <template v-slot:item.sumTotalPackages="{ item }">
                {{ item.sumTotalPackages }} ({{ item.packageName }})
              </template>
            </v-data-table>
          </b-col>
        </b-row>
      </template>
      <v-skeleton-loader
        v-if="isPageLoading"
        :loading="isPageLoading"
        type="table"
      ></v-skeleton-loader>
      <v-overlay :value="!firstLoader && isPageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <template v-slot:footer></template>
    </b-card>
  </div>
</template>
<style scoped>
tr.previewTr th {
  font-size: 18px !important;
}
</style>
<script>
//General
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import { mapGetters } from "vuex";

//Audit Module
import {
  FETCH_PROCESSING_ORDER_ITEMS,
  FETCH_PROCESSING_ORDER_ITEMS_XLS
} from "@/modules/stock/store/stock.module";

import { FETCH_STORES_WAREHOUSES } from "@/core/services/store/shared_store.module";

import { permissionMixin } from "@/core/mixins/permissionMixin.js";
import moment from "moment";

export default {
  name: "StockPurchaseOrderProduction",
  mixins: [permissionMixin],
  data() {
    return {
      search: "",
      firstLoader: true,
      isPageLoading: true,
      items: [],
      stores: [],
      filters: {
        warehouseId: null
      },
      columns: {},
      cancelSource: null,
      selectedHeaders: [],
      headers: [],
      headersMap: {
        id: {
          text: this.$t("ID"),
          value: "id",
          groupable: false,
          show: true
        },
        code: {
          text: this.$t("CODE"),
          value: "code",
          groupable: false,
          show: true
        },
        warehouse: {
          text: this.$t("WAREHOUSE"),
          value: "warehouseName",
          show: true
        },
        item: {
          text: this.$t("ITEM_PRODUCT"),
          value: "name",
          groupable: false,
          show: true
        },
        pp: {
          text: this.$t("PROCESSING_PACKAGES"),
          value: "sumPackages",
          groupable: false,
          show: false
        },
        pq: {
          text: this.$t("PROCESSING_QUANTITY"),
          value: "sumQuantity",
          groupable: false,
          show: false
        },
        rp: {
          text: this.$t("REQUESTED_PACKAGES"),
          value: "sumRequestedPackages",
          groupable: false,
          show: false
        },
        rq: {
          text: this.$t("REQUESTED_QUANTITY"),
          value: "sumRequestedQuantity",
          groupable: false,
          show: false
        },
        tp: {
          text: this.$t("TOTAL_PACKAGES"),
          value: "sumTotalPackages",
          groupable: false,
          show: true
        },
        tq: {
          text: this.$t("TOTAL_QUANTITY"),
          value: "sumTotalQuantity",
          groupable: false,
          show: true
        }
      }
    };
  },
  components: {},
  watch: {
    storesParams(value) {
      let vm = this;
      vm.filters.warehouseId = null;
      vm.getStores();
    }
  },
  created() {
    this.headers = Object.values(this.headersMap);
    this.selectedHeaders = this.headers.filter(header => header.show);
  },
  mounted() {
    let vm = this;
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Stock Processing Order Items" }
    ]);
    vm.getStores();
  },
  computed: {
    ...mapGetters(["isLoadingStock"]),
    params() {
      return {
        warehouseId: this.filters.warehouseId
      };
    },
    tableHeaders() {
      let vm = this;
      return vm.headers;
    },
    showHeaders() {
      return this.headers.filter(s => this.selectedHeaders.includes(s));
    }
  },
  methods: {
    clearFilter(key) {
      let vm = this;
      vm.$nextTick(function() {
        this.$set(vm.filters, key, null);
      });
    },
    cancelRequest() {
      //Axios cancelSource to stop current search if new value is entered
      if (this.cancelSource) {
        this.cancelSource.cancel("Start new search, stop active search");
      }
    },
    doSearch() {
      let vm = this;
      vm.getDataFromApi();
    },
    getDataFromApi() {
      let vm = this;
      //copy current params to modify
      let params = this.params;
      let apiParams = vm.transformUrlParams(params);
      // console.log(apiParams);
      vm.$store
        .dispatch(FETCH_PROCESSING_ORDER_ITEMS, apiParams)
        .then(({ data }) => {
          vm.firstLoader = false;
          vm.$nextTick(function() {
            vm.items = data ? data : [];

            if (vm.isPageLoading == true) {
              vm.isPageLoading = false;
            }
          });
        })
        .catch(response => {
          console.log(response);
          if (response.status === 404) {
            vm.$notify({
              group: "notify",
              type: "error",
              text: "Nout Found"
            });
            this.$router.push({ name: "stock-purchase-orders-list" });
          }
        });
    },
    getXLS() {
      let vm = this;
      vm.isLoadingStoreDailyTasks = true;
      let params = {
        warehouseId: vm.filters.warehouseId
      };
      let apiParams = vm.transformUrlParams(params);
      this.$store
        .dispatch(FETCH_PROCESSING_ORDER_ITEMS_XLS, apiParams)
        .then(data => {
          vm.firstLoader = false;
          vm.$nextTick(function() {
            let blob = new Blob([data], {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download =
              "stock-processing-order-items-" + moment().format("DD-MM-YYYY");
            link.click();
            link.remove();
            vm.dialogMZxml = false;
            if (vm.isPageLoading == true || vm.isXmlMzLoading == true) {
              vm.isPageLoading = false;
              vm.isXmlMzLoading = false;
            }
          });
        })
        .catch(response => {
          console.log(response);
          if (response.status === 404) {
            vm.$notify({
              group: "notify",
              type: "error",
              text: "Not Found"
            });
          }
        });
    },
    getStores() {
      let vm = this;
      let params = {};
      let apiParams = vm.transformUrlParams(params);
      this.$store
        .dispatch(FETCH_STORES_WAREHOUSES, apiParams)
        .then(data => {
          this.$set(vm, "stores", data.data);
          vm.filters.warehouseId = data.data[0].id;
          vm.getDataFromApi();
        })
        .catch(response => {
          console.log(response);
        });
    },
    transformUrlParams(params) {
      let apiParams =
        "?" +
        Object.keys(params)
          .map(key => key + "=" + params[key])
          .join("&");
      return apiParams;
    }
  }
};
</script>
